module.exports = __webpack_public_path__ + "static/bigminerLogoSmall-ba3e9ad905d0a7b2d7bd07b00ca4ae78.svg";